export default __webpack_public_path__ + "static/media/welcome_bg.774c38c0.png";